/** Roles that can open the Tags page. Engineers manage tag history and sources through chat. */
export const TAGS_PAGE_ROLES = ['global_admin', 'admin'] as const

export function canOpenTagsPage(
  authz: { permissions: readonly string[]; roles: readonly string[] } | undefined
): boolean {
  return (
    authz !== undefined &&
    authz.permissions.includes('tag/inventory-read') &&
    TAGS_PAGE_ROLES.some((role) => authz.roles.includes(role))
  )
}
